
import { StrategyWithDetails } from "@/types/strategy-types";

export const transformStrategyData = (data: any[]) => {
  return data.map(item => ({
    ...item,
    provider_name: item.strategy_provider?.name || 'N/A',
    // Map fields to match what the UI expects
    strategy_name: item.name || '',
    followers_count: item.followers_count || 0,
    performance_percentage: item.expected_monthly_profit || 0,
    performance_since: item.verified_since || new Date().toISOString(),
    is_pro: item.plan === 'premium' || item.plan === 'pro',
    is_active: item.active || false,
    max_drawdown: item.defined_max_drawdown || 0,
    created_at: item.created_at || new Date().toISOString()
  }));
};
